"use client";

import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";

export function ThemeToggle({ className }: { className?: string }) {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const isDark = resolvedTheme === "dark";

  return (
    <button
      type="button"
      aria-label="Toggle theme"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className={cn(
        "relative h-10 w-10 rounded-full glass flex items-center justify-center",
        "hover:border-[rgb(var(--accent)/0.6)] transition-colors duration-300",
        className,
      )}
    >
      <Sun
        className={cn(
          "h-[1.15rem] w-[1.15rem] absolute transition-all duration-500 text-[var(--color-amber)]",
          mounted && isDark ? "opacity-0 rotate-90 scale-0" : "opacity-100 rotate-0 scale-100",
        )}
      />
      <Moon
        className={cn(
          "h-[1.15rem] w-[1.15rem] absolute transition-all duration-500 text-[var(--color-violet)]",
          mounted && isDark ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-0",
        )}
      />
    </button>
  );
}
